export default __webpack_public_path__ + "static/media/teamwork_inactive.e5496989.svg";